module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-B.338d5006.png";